module.exports = __webpack_public_path__ + "img/AU.b15adc67.png";